/*!
 * ymm-bar.js — persistent header YMM bar. Shows the active vehicle ("Shopping for …") or a prompt,
 * opens a Make/Model/Year + VIN picker, and offers recent vehicles. Re-renders on 'ymm:garage'.
 * Mount: [data-ymm-bar] with optional data-collection + data-shop-link.
 */
(function (w) {
  'use strict';
  function el(t, c, h) { var e = document.createElement(t); if (c) e.className = c; if (h != null) e.innerHTML = h; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function slug(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  // Resolve a picked/decoded vehicle to the DEEPEST What Fits page: leaf → family hub → make hub →
  // older-bike landing (pre-1996, always screen-only) → What Fits. Mirrors sections/ymm-quicklookup.liquid.
  function bestFitUrl(veh) {
    if (!veh || !veh.year) return '/pages/what-fits';
    var mk = (veh.make === 'indian' || veh.mk === 'indian') ? 'indian' : 'harley-davidson';
    var L = w.YMM_LEAVES || [];
    var leaf = veh.year + '-' + mk + '-' + slug(veh.model || veh.rmodel);
    if (L.indexOf(leaf) !== -1) return '/pages/' + leaf;
    if (+veh.year < 1996) {
      return '/pages/carplay-for-older-motorcycles?year=' + encodeURIComponent(veh.year) +
        '&make=' + encodeURIComponent(veh.mk_name || 'Harley-Davidson') + '&model=' + encodeURIComponent(veh.model || '');
    }
    var fam = veh.vfam || veh.ffam || veh.family;
    if (fam) return '/pages/' + veh.year + '-' + mk + '-' + slug(fam) + '-models';
    return '/pages/' + veh.year + '-' + mk;
  }
  // Route to the resolved page, but only after the leaf set has loaded so a fast pick never falls to a hub.
  function routeToFit(veh) {
    var go = function () { w.location.href = bestFitUrl(veh); };
    if (w.YMM_LEAVES_READY && w.YMM_LEAVES_READY.then) { w.YMM_LEAVES_READY.then(go); } else { go(); }
  }

  function YMMBar(mount) {
    this.el = typeof mount === 'string' ? document.querySelector(mount) : mount;
    if (!this.el) return;
    this.collection = this.el.getAttribute('data-collection') || '/collections/all';
    this.shopLink = this.el.getAttribute('data-shop-link') || '/pages/fitment';
    var self = this;
    this.el.classList.add('ymm-bar');
    this.build();
    document.addEventListener('ymm:garage', function () { self.renderState(); });
    w.YMM.onReady(function () { self.renderState(); });
    this.renderState();
  }

  YMMBar.prototype.build = function () {
    var self = this;
    this.state = el('div', 'ymm-bar__state');
    this.panel = el('div', 'ymm-bar__panel');
    var inner = el('div', 'ymm-bar__inner');
    inner.appendChild(this.state);
    this.el.innerHTML = '';
    this.el.appendChild(inner);
    this.el.appendChild(this.panel);
  };

  YMMBar.prototype.togglePanel = function (open) {
    var willOpen = open == null ? !this.panel.classList.contains('is-open') : open;
    this.panel.classList.toggle('is-open', willOpen);
    if (willOpen && !this.widget) this.mountWidget();
  };

  YMMBar.prototype.mountWidget = function () {
    var self = this;
    var host = el('div');
    var recent = w.YMMGarage ? w.YMMGarage.list() : [];
    if (recent.length) {
      var r = el('div', 'ymm-bar__recent', '<span class="ymm-bar__recent-lbl">Recent:</span>');
      recent.forEach(function (veh) {
        var b = el('button', 'ymm-bar__chip', esc(veh.label)); b.type = 'button';
        b.addEventListener('click', function () { if (w.YMMGarage) w.YMMGarage.set(veh); self.togglePanel(false); routeToFit(veh); });
        r.appendChild(b);
      });
      this.panel.appendChild(r);
    }
    this.panel.appendChild(host);
    this.widget = new w.YMMWidget(host, { vin: true, onApply: function (veh) {
      if (w.YMMGarage) w.YMMGarage.set(veh);
      self.togglePanel(false);
      routeToFit(veh);
    } });
  };

  YMMBar.prototype.renderState = function () {
    var self = this;
    var veh = w.YMMGarage && w.YMMGarage.get();
    this.state.innerHTML = '';
    var icon = '<svg class="ymm-bar__ico" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="5.5" cy="17.5" r="3.5"/><circle cx="18.5" cy="17.5" r="3.5"/><path d="M5.5 17.5h6l3-6h4"/><path d="M9 17.5l3-9h3"/></svg>';
    if (veh) {
      this.state.innerHTML = icon +
        '<span class="ymm-bar__label">Shopping for <strong>' + esc(veh.label).replace(/\b(Harley-Davidson|Indian)\b\s*/i, '').replace(/\s{2,}/g, ' ').trim() + '</strong></span>';
      var change = el('button', 'ymm-bar__btn', 'Change'); change.type = 'button';
      change.addEventListener('click', function () { self.togglePanel(); });
      var clear = el('button', 'ymm-bar__btn ymm-bar__btn--ghost', 'Clear'); clear.type = 'button';
      clear.addEventListener('click', function () { if (w.YMMGarage) w.YMMGarage.clear(); self.togglePanel(false); });
      this.state.appendChild(change); this.state.appendChild(clear);
    } else {
      this.state.innerHTML = icon + '<span class="ymm-bar__label">Find parts for your motorcycle</span>';
      var pick = el('button', 'ymm-bar__btn', 'Shop by bike'); pick.type = 'button';
      pick.addEventListener('click', function () { self.togglePanel(); });
      this.state.appendChild(pick);
    }
  };

  w.YMMBar = YMMBar;
  document.addEventListener('DOMContentLoaded', function () {
    var m = document.querySelector('[data-ymm-bar]');
    if (m) new YMMBar(m);
  });
})(window);
